export const UserModel = {
  id: "",
  userId: "",
  username: "",
  firstName: "",
  lastName: "",
  email: "",
  phone: "",
  dateOfBirth: "",
  gender: "",
  street: "",
  city: "",
  state: "",
  zipCode: "",
  userMedia: {
    id: "",
    mediaType: "",
    mediaUrl: "",
    blobName: "",
  },
};

export const UserSummaryModel = {
  userId: "",
  firstName: "",
  lastName: "",
  profilePictureUrl: "",
};
